import Raven from 'raven-js';

import LogRocket from './logrocket';
import { REPORTING_ENABLED } from './is-production-host';


// A fetch() the browser couldn't complete (offline, a laptop waking up, an ad blocker, a tab
// closed mid-request): Chrome says "Failed to fetch", Safari "Load failed", Firefox "NetworkError
// when attempting to fetch resource.". One new Sentry issue per call site, nothing to fix on our
// side. Raven tests both the message and "TypeError: <message>".
export const IGNORED_ERRORS = [
  /^(TypeError: )?Failed to fetch$/,
  /^(TypeError: )?Load failed$/,
  /^(TypeError: )?NetworkError when attempting to fetch resource\.$/,
];


// Configure Raven client
if (REPORTING_ENABLED && ! Raven.isSetup()) {
  const ravenInstance = Raven.config('https://36078163e35942a790d8fea24c81debb@sentry.io/178638', {
    autoBreadcrumbs: false,  // Prevent raven from wrapping every console log
    environment: process.env.APP_ENV,
    ignoreErrors: IGNORED_ERRORS,
  });

  Raven.setDataCallback((data) => {
    data.extra.sessionURL = LogRocket.sessionURL;
    return data;
  });

  ravenInstance.install();

  fetch('/version.json')
    .then((response) => response.status !== 500 ? response.json() : {})
    .then((body) => Raven.setRelease(body.version));
}


export default {
  captureException: REPORTING_ENABLED
    ? Raven.captureException.bind(Raven)
    : x => x,
  setUserContext: REPORTING_ENABLED
    ? Raven.setUserContext.bind(Raven)
    : x => x,
};
